import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { NewUrlInputModal, BUTTON_SIZE } from 'wix-rich-content-ui-components';
import { LINK_PREVIEW_TYPE } from '../types.js';
import { MEDIA_POPOVERS_BUTTONS_NAMES_BI } from 'wix-rich-content-common';
import { EMBED_DEFAULTS } from '../defaults.js';
import { SOCIAL_EMBED_MODAL } from '../dataHooks.js';

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
class SocialEmbedInsertModal extends Component {
  constructor(props) {
    var _a, _b;
    super(props);
    __publicField(this, "onConfirm", () => {
      var _a;
      const { url } = this.state;
      const { componentData, onConfirm, helpers, fetchData, closeModal } = this.props;
      (_a = helpers == null ? void 0 : helpers.onPluginsPopOverClick) == null ? void 0 : _a.call(helpers, {
        pluginId: LINK_PREVIEW_TYPE,
        buttonName: MEDIA_POPOVERS_BUTTONS_NAMES_BI.embed
      });
      if (url) {
        fetchData(url).then(({ html }) => {
          if (!html) {
            this.setState({ submittedInvalidUrl: true });
          } else {
            onConfirm(__spreadProps(__spreadValues(__spreadValues({}, componentData), EMBED_DEFAULTS), {
              src: url,
              oembed: {
                type: "rich",
                html
              }
            }));
            closeModal == null ? void 0 : closeModal();
          }
        });
      }
    });
    __publicField(this, "onCloseRequested", () => {
      var _a;
      const { helpers, closeModal } = this.props;
      (_a = helpers == null ? void 0 : helpers.onPluginsPopOverClick) == null ? void 0 : _a.call(helpers, {
        pluginId: LINK_PREVIEW_TYPE,
        buttonName: MEDIA_POPOVERS_BUTTONS_NAMES_BI.cancel
      });
      closeModal == null ? void 0 : closeModal();
    });
    const { componentData } = this.props;
    this.state = {
      url: ((_b = (_a = componentData == null ? void 0 : componentData.config) == null ? void 0 : _a.link) == null ? void 0 : _b.url) || "",
      submittedInvalidUrl: false
    };
  }
  render() {
    const { url, submittedInvalidUrl } = this.state;
    const { t, languageDir, socialType, helpers, isMobile, showCloseButton } = this.props;
    return /* @__PURE__ */ React.createElement(
      NewUrlInputModal,
      {
        onConfirm: this.onConfirm,
        helpers,
        input: url,
        t,
        languageDir,
        title: t(`EmbedURL_Social_${socialType}_Title`),
        saveLabel: t("Embed_Add_Button_Label"),
        submittedInvalidUrl,
        dataHook: SOCIAL_EMBED_MODAL,
        onInputChange: (url2) => this.setState({ url: url2 }),
        errorMessage: t("SoundCloudUploadModal_Input_InvalidUrl"),
        placeholder: t(`EmbedURL_Social_${socialType}_Placeholder`),
        onCloseRequested: this.onCloseRequested,
        buttonSize: BUTTON_SIZE.medium,
        isMobile,
        withMobileSaveButton: true,
        showCloseButton
      }
    );
  }
}
SocialEmbedInsertModal.propTypes = {
  helpers: PropTypes.object.isRequired,
  componentData: PropTypes.object.isRequired,
  t: PropTypes.func,
  languageDir: PropTypes.string,
  fetchData: PropTypes.func,
  socialType: PropTypes.string,
  isMobile: PropTypes.bool,
  experiments: PropTypes.object,
  onConfirm: PropTypes.func.isRequired,
  closeModal: PropTypes.func,
  showCloseButton: PropTypes.bool
};

export { SocialEmbedInsertModal as default };
//# sourceMappingURL=SocialEmbedInsertModal.js.map
